// extracted by mini-css-extract-plugin
export default {"formSampleModalContainer":"AddFormSampleModal_formSampleModalContainer__DS8Ji","bgRef":"AddFormSampleModal_bgRef__x775l","content":"AddFormSampleModal_content__2sYl0"};